import inventoryAPI from '@/services/api/inventory'
import SortUtil from '@/utils/modules/SortUtil'

const index = {
	namespaced: true,
	state: () => ({
		dumpList: [],
		count: undefined,
		offset: 0,
		sortType: 1,
	}),
	getters: {
		getDumpListAsFilter: state => {
			// 인벤토리 데이터 자료구조를 변경하는 getter
			const filteredData = []
			const result = {}

			if (state.dumpList) {
				for (
					let listIdx = 0;
					listIdx < state.dumpList.length;
					listIdx++
				) {
					const item = state.dumpList[listIdx]
					switch (state.sortType) {
						case 1:
							if (item.isDispose) {
								filteredData.push(
									item.disposeDatetime.substr(0, 10)
								)
							} else if (item.isDel) {
								filteredData.push(
									item.deleteDatetime.substr(0, 10)
								)
							}
							break
						case 2:
							filteredData.push(
								SortUtil.getKorChosung(
									item.name[0]
								).toUpperCase()
							)
							break
						case 3:
							const { location, storage } = item
							filteredData.push(
								SortUtil.makeFullStoragePath(
									location.pathName,
									storage.pathName
								)
							)
							break
					}
				}

				const removeDuplicateData = [...new Set([...filteredData])]
				for (let idx = 0; idx < removeDuplicateData.length; idx++) {
					const dataKey = removeDuplicateData[idx]
					result[dataKey] = state.dumpList.filter(item => {
						let filterFunciton = () => {}
						switch (state.sortType) {
							case 1:
								if (item.isDispose) {
									filterFunciton =
										item.disposeDatetime.substr(0, 10) ===
										dataKey
								} else if (item.isDel) {
									filterFunciton =
										item.deleteDatetime.substr(0, 10) ===
										dataKey
								}
								break
							case 2:
								filterFunciton =
									SortUtil.getKorChosung(
										item.name[0].toUpperCase()
									) === dataKey
								break
							case 3:
								const { location, storage } = item
								filterFunciton =
									SortUtil.makeFullStoragePath(
										location.pathName,
										storage.pathName
									) === dataKey
								break
						}
						return filterFunciton
					})
				}
			}
			return result
		},
	},
	mutations: {
		setDumpList: (state, payload) => {
			const { list, count } = payload
			state.dumpList = list
			state.count = count
		},
		addDumpList: (state, payload) => {
			const { list } = payload
			state.dumpList = [...state.dumpList, ...list]
		},
	},
	actions: {
		loadDumpList: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupDumpList(
				instId,
				paramsObject
			)
			commit('setDumpList', response.data)
		},
		addDumpList: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupDumpList(
				instId,
				paramsObject
			)
			commit('addDumpList', response.data)
		},
	},
}
export default index
